import { gql } from '@/__generated__';

const GET_DEVICE_ORGANIZATION = gql(`#graphql
  query CollectionsAccessTab_GetDeviceOrganization($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      profile {
        id
        organization {
          id
        }
      }
    }
  }
`);

export default GET_DEVICE_ORGANIZATION;
